/* tslint:disable */
/* eslint-disable */
/**
 * data-center
 * data-center
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OmniGenerateIFrameUrlResponse
 */
export interface OmniGenerateIFrameUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof OmniGenerateIFrameUrlResponse
     */
    iframe_url: string;
}

/**
 * Check if a given object implements the OmniGenerateIFrameUrlResponse interface.
 */
export function instanceOfOmniGenerateIFrameUrlResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "iframe_url" in value;

    return isInstance;
}

export function OmniGenerateIFrameUrlResponseFromJSON(json: any): OmniGenerateIFrameUrlResponse {
    return OmniGenerateIFrameUrlResponseFromJSONTyped(json, false);
}

export function OmniGenerateIFrameUrlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OmniGenerateIFrameUrlResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iframe_url': json['iframe_url'],
    };
}

export function OmniGenerateIFrameUrlResponseToJSON(value?: OmniGenerateIFrameUrlResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iframe_url': value.iframe_url,
    };
}

